<div class="p-6 max-w-3xl mx-auto">

  <!-- Breadcrumb -->
  <nav class="flex items-center gap-2 text-sm text-gray-500 mb-5">
    <a routerLink="/automation/workflows" class="hover:text-blue-600 transition-colors">Workflows</a>
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
    </svg>
    @if (workflowId && workflow) {
      <a routerLink="/automation/workflows" class="hover:text-blue-600 transition-colors">
        {{ workflow.name }}
      </a>
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
      </svg>
    }
    <span class="text-gray-900 dark:text-white font-medium">Probar disparador</span>
  </nav>

  <h1 class="text-xl font-semibold text-gray-900 dark:text-white mb-1">Probador de disparadores</h1>
  <p class="text-sm text-gray-500 dark:text-gray-400 mb-5">
    Envía un evento al motor de workflows para probar si coincide con tus disparadores activos.
  </p>

  <!-- Plantillas rápidas -->
  <div class="mb-5">
    <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Plantillas rápidas</p>
    <div class="flex flex-wrap gap-2">
      @for (tpl of eventTemplates; track tpl.eventType) {
        <button (click)="applyTemplate(tpl)"
                class="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:border-blue-300 text-gray-600 dark:text-gray-300 transition-colors">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
          </svg>
          {{ tpl.label }}
        </button>
      }
    </div>
  </div>

  <!-- Messages -->
  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span>
      <button (click)="error = ''">&times;</button>
    </div>
  }

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">

    <!-- Formulario -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Datos del evento</h2>
      <form [formGroup]="form" (ngSubmit)="sendEvent()" novalidate>
        <div class="space-y-3">

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Tipo de evento <span class="text-red-500">*</span>
            </label>
            <input type="text" formControlName="eventType" placeholder="Ej: CONTACT_CREATED"
                   [class]="'w-full px-3 py-2 text-sm border rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ' + (isFieldInvalid('eventType') ? 'border-red-400' : 'border-gray-200 dark:border-gray-600')"/>
            @if (isFieldInvalid('eventType')) {
              <p class="text-xs text-red-500 mt-0.5">El tipo de evento es obligatorio.</p>
            }
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Tipo de objeto <span class="text-red-500">*</span>
            </label>
            <select formControlName="objectType"
                    class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
              @for (ot of objectTypeOptions; track ot.value) {
                <option [value]="ot.value">{{ ot.label }}</option>
              }
            </select>
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Registro <span class="text-red-500">*</span>
            </label>
            @if (recordSelect.isSearchable()) {
              <app-entity-select
                [value]="form.value.objectId"
                (valueChange)="form.patchValue({ objectId: $event })"
                (selected)="onRecordSelected($event)"
                [displayText]="recordDisplayText"
                [searchFn]="recordSelect.search" [labelFn]="recordSelect.label" [sublabelFn]="recordSelect.sublabel"
                placeholder="Buscar por nombre…"></app-entity-select>
            } @else {
              <input type="number" formControlName="objectId" placeholder="Ej: 42" min="1"
                     [class]="'w-full px-3 py-2 text-sm border rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ' + (isFieldInvalid('objectId') ? 'border-red-400' : 'border-gray-200 dark:border-gray-600')"/>
              <p class="text-xs text-gray-400 mt-0.5">Este tipo aún no tiene buscador; ingresa el ID.</p>
            }
            @if (isFieldInvalid('objectId')) {
              <p class="text-xs text-red-500 mt-0.5">Selecciona un registro.</p>
            }
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Módulo de origen</label>
            <input type="text" formControlName="sourceModule" placeholder="Ej: CONTACT, DEAL"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Clave de origen</label>
            <input type="text" formControlName="sourceKey" placeholder="Clave de idempotencia opcional"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>

          <p class="text-xs text-gray-400 dark:text-gray-500">
            Los datos del evento se toman de la plantilla seleccionada; no necesitas editar JSON.
          </p>

          <button type="submit" [disabled]="loading"
                  class="w-full py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors inline-flex items-center justify-center gap-2">
            @if (loading) {
              <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
              </svg>
              Enviando...
            } @else {
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
              </svg>
              Enviar evento
            }
          </button>
        </div>
      </form>
    </div>

    <!-- Resultado -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Resultado</h2>

      @if (!result && !loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-300 dark:text-gray-600">
          <svg class="w-10 h-10 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          <p class="text-sm">Envía un evento para ver el resultado aquí</p>
        </div>
      }

      @if (loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-400">
          <svg class="animate-spin w-8 h-8 mb-3" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
          </svg>
          <p class="text-sm">Procesando evento...</p>
        </div>
      }

      @if (result && !loading) {
        <!-- Estado general -->
        <div class="flex items-center gap-2 mb-4 p-3 rounded-lg"
             [ngClass]="result.ignored ? 'bg-gray-50 dark:bg-gray-700/40' : (resultEnrollmentCount > 0 ? 'bg-green-50 dark:bg-green-900/20' : 'bg-blue-50 dark:bg-blue-900/20')">
          @if (result.ignored) {
            <svg class="w-5 h-5 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <div>
              <p class="text-sm font-medium text-gray-600 dark:text-gray-400">Ningún workflow activo coincidió con este evento</p>
              <p class="text-xs text-gray-500">
                No se inscribió ningún registro. Revisa que exista un workflow <strong>activo</strong> cuyo disparador
                coincida con este tipo de evento y objeto, y que el registro cumpla los criterios de inscripción.
              </p>
              @if (result.message) {
                <p class="text-xs text-gray-400 mt-1">Detalle técnico: {{ result.message }}</p>
              }
            </div>
          } @else if (resultEnrollmentCount > 0) {
            <svg class="w-5 h-5 text-green-600 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <div>
              <p class="text-sm font-medium text-green-700 dark:text-green-400">
                {{ resultEnrollmentCount }} inscripción(es) creada(s)
              </p>
              <p class="text-xs text-green-600 dark:text-green-500">{{ result.message }}</p>
            </div>
          } @else {
            <svg class="w-5 h-5 text-blue-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <div>
              <p class="text-sm font-medium text-blue-700 dark:text-blue-400">Evento procesado</p>
              <p class="text-xs text-blue-600">{{ result.message }}</p>
            </div>
          }
        </div>

        <!-- Métricas -->
        <dl class="grid grid-cols-2 gap-3 mb-4">
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-2.5">
            <dt class="text-xs text-gray-500 dark:text-gray-400">Workflows coincidentes</dt>
            <dd class="text-lg font-semibold text-gray-900 dark:text-white">{{ result.matchedWorkflows ?? 0 }}</dd>
          </div>
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-2.5">
            <dt class="text-xs text-gray-500 dark:text-gray-400">Inscripciones creadas</dt>
            <dd class="text-lg font-semibold text-gray-900 dark:text-white">{{ resultEnrollmentCount }}</dd>
          </div>
          @if (result.queueItemId) {
            <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-2.5">
              <dt class="text-xs text-gray-500 dark:text-gray-400">Queue Item ID</dt>
              <dd class="text-sm font-mono text-gray-900 dark:text-white">#{{ result.queueItemId }}</dd>
            </div>
          }
          <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-2.5">
            <dt class="text-xs text-gray-500 dark:text-gray-400">Procesado</dt>
            <dd class="text-sm font-semibold" [class]="result.processed ? 'text-green-600' : 'text-yellow-600'">
              {{ result.processed ? 'Sí' : 'En cola' }}
            </dd>
          </div>
        </dl>

        <!-- Enrollments creados -->
        @if (result.createdEnrollments?.length) {
          <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
            Inscripciones creadas
          </h3>
          <div class="space-y-3">
            @for (en of result.createdEnrollments; track en.id) {
              <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg px-3 py-2">
                <div class="flex items-center justify-between mb-1">
                  <div class="flex items-center gap-2">
                    <span class="text-xs font-medium text-gray-900 dark:text-white">
                      #{{ en.id }} — {{ recordText(en.objectType, en.objectId) }}
                    </span>
                    <span class="text-xs px-1.5 py-0.5 rounded-full bg-green-100 text-green-700">{{ statusText(en.status) }}</span>
                  </div>
                  <div class="flex items-center gap-1.5">
                    @if (workflowId) {
                      <a [routerLink]="['/automation/workflows', workflowId, 'enrollments']"
                         class="text-xs text-blue-600 hover:underline">Ver</a>
                    }
                    <button (click)="continueEnrollment(en)"
                            [disabled]="continuingEnrollmentId === en.id"
                            class="inline-flex items-center gap-1 px-2 py-0.5 text-xs bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50 transition-colors">
                      @if (continuingEnrollmentId === en.id) {
                        <svg class="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
                        </svg>
                      } @else {
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
                        </svg>
                      }
                      Continuar
                    </button>
                  </div>
                </div>

                <!-- Resultado de continuar -->
                @if (getContinueError(en.id)) {
                  <p class="text-xs text-red-500 mt-1">{{ getContinueError(en.id) }}</p>
                }
                @if (getContinueResult(en.id)) {
                  @let cr = getContinueResult(en.id)!;
                  <div class="mt-2 p-2 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded text-xs">
                    <div class="flex items-center gap-2 flex-wrap">
                      <span class="text-indigo-700 dark:text-indigo-300">{{ getContinueMessage(cr) }}</span>
                      @if (cr.branch?.selectedBranchKey) {
                        <span class="px-2 py-0.5 bg-indigo-600 text-white rounded-full font-bold text-[10px]">
                          Rama: {{ branchLabel(cr.branch!.selectedBranchKey) }}
                        </span>
                      }
                      @if (cr.nextNodeType) {
                        <span class="text-indigo-500">→ {{ nodeTypeText(cr.nextNodeType) }}</span>
                      }
                    </div>
                    <!-- Info de acción RF-06/RF-07/RF-08 -->
                    @if (isActionResult(cr)) {
                      <div class="mt-2 p-2 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded text-xs">
                        <div class="flex items-center gap-2 flex-wrap text-green-700 dark:text-green-400">
                          <span class="font-semibold">Acción ejecutada</span>
                          @if (cr.details?.['actionType']) {
                            <span class="px-1.5 py-0.5 bg-green-100 dark:bg-green-900/30 rounded text-[10px]">
                              {{ nodeSubtypeText(cr.details!['actionType']) }}
                            </span>
                          }
                          @if (cr.details?.['actionStatus']) {
                            <span class="px-1.5 py-0.5 rounded text-[10px] font-bold"
                                  [ngClass]="getActionStatusClass(cr.details!['actionStatus'])">
                              {{ statusText(cr.details!['actionStatus']) }}
                            </span>
                          }
                        </div>
                        @if (cr.details?.['targetObjectType']) {
                          <p class="text-green-600 dark:text-green-400 mt-0.5">
                            Resultado: {{ recordText(cr.details!['targetObjectType'], cr.details!['targetObjectId']) }}
                          </p>
                        }
                        @if (cr.details?.['actionStatus'] === 'SKIPPED') {
                          <p class="text-gray-500 mt-0.5">
                            Razón: {{ cr.details!['skipReason'] ?? 'Integración no configurada o consentimiento rechazado.' }}
                          </p>
                        }
                        <!-- RF-08: CREATE_TASK -->
                        @if (cr.details?.['actionType'] === 'CREATE_TASK' && cr.details?.['output']) {
                          <div class="mt-1.5 p-1.5 bg-teal-50 dark:bg-teal-900/20 border border-teal-200 dark:border-teal-800 rounded text-[10px] space-y-0.5">
                            <p class="font-semibold text-teal-700 dark:text-teal-400">Tarea creada</p>
                            @if (cr.details!['output']['taskId']) {
                              <p class="text-teal-600">ID: <span class="font-mono">{{ cr.details!['output']['taskId'] }}</span></p>
                            }
                            @if (cr.details!['output']['title']) {
                              <p class="text-teal-600">Título: {{ cr.details!['output']['title'] }}</p>
                            }
                            @if (cr.details!['output']['assignedTo']) {
                              <p class="text-teal-600">Asignado a: {{ cr.details!['output']['assignedTo'] }}</p>
                            }
                            @if (cr.details!['output']['dueDate']) {
                              <p class="text-teal-600">Vence: {{ cr.details!['output']['dueDate'] }}</p>
                            }
                          </div>
                        }
                        <!-- RF-08: CREATE_NOTE -->
                        @if (cr.details?.['actionType'] === 'CREATE_NOTE' && cr.details?.['actionStatus'] === 'SUCCESS') {
                          <div class="mt-1.5 p-1.5 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded text-[10px]">
                            <p class="font-semibold text-blue-700 dark:text-blue-400">Nota registrada en historial / audit log.</p>
                          </div>
                        }
                        <!-- RF-08: COMPLETE_TASK -->
                        @if (cr.details?.['actionType'] === 'COMPLETE_TASK' && cr.details?.['output']) {
                          <div class="mt-1.5 p-1.5 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded text-[10px] space-y-0.5">
                            <p class="font-semibold text-green-700 dark:text-green-400">Tarea completada</p>
                            @if (cr.details!['output']['taskId']) {
                              <p class="text-green-600">ID: <span class="font-mono">{{ cr.details!['output']['taskId'] }}</span></p>
                            }
                          </div>
                        }
                        <!-- RF-10: SEND_WEBHOOK -->
                        @if (cr.details?.['actionType'] === 'SEND_WEBHOOK' && cr.details?.['output']) {
                          <div class="mt-1.5 p-1.5 bg-sky-50 dark:bg-sky-900/20 border border-sky-200 dark:border-sky-800 rounded text-[10px] space-y-0.5">
                            <p class="font-semibold text-sky-700 dark:text-sky-400">Webhook enviado</p>
                            @if (cr.details!['output']['httpStatus']) {
                              <p class="text-sky-600">HTTP: <span class="font-mono font-medium">{{ cr.details!['output']['httpStatus'] }}</span></p>
                            }
                            @if (cr.details!['output']['durationMs'] !== undefined) {
                              <p class="text-sky-600">Duración: <span class="font-mono">{{ cr.details!['output']['durationMs'] }}ms</span></p>
                            }
                          </div>
                        }
                        <!-- RF-10: NATIVE_INTEGRATION_ACTION / CODE_SNIPPET SKIPPED -->
                        @if ((cr.details?.['actionType'] === 'NATIVE_INTEGRATION_ACTION' || cr.details?.['actionType'] === 'CODE_SNIPPET') && cr.details?.['actionStatus'] === 'SKIPPED') {
                          <div class="mt-1.5 p-1.5 bg-gray-50 dark:bg-gray-700/40 border border-gray-200 dark:border-gray-600 rounded text-[10px]">
                            <p class="text-gray-500 dark:text-gray-400">
                              {{ cr.details!['actionType'] === 'CODE_SNIPPET' ? 'Fragmento de código: entorno de ejecución pendiente.' : 'Integración nativa pendiente.' }} La acción se registró como omitida.
                            </p>
                          </div>
                        }
                        <!-- RF-09: CHANGE_DEAL_STAGE -->
                        @if (cr.details?.['actionType'] === 'CHANGE_DEAL_STAGE' && cr.details?.['output']) {
                          <div class="mt-1.5 p-1.5 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded text-[10px] space-y-0.5">
                            <p class="font-semibold text-orange-700 dark:text-orange-400">Negocio actualizado</p>
                            @if (cr.details!['output']['oldStageId'] !== undefined) {
                              <p class="text-orange-600">Etapa anterior: <span class="font-mono">{{ cr.details!['output']['oldStageId'] }}</span></p>
                            }
                            @if (cr.details!['output']['newStageId'] !== undefined) {
                              <p class="text-orange-600">Etapa nueva: <span class="font-mono font-medium">{{ cr.details!['output']['newStageId'] }}</span></p>
                            }
                          </div>
                        }
                        <!-- RF-09: UPDATE_DEAL_CLOSE_DATE -->
                        @if (cr.details?.['actionType'] === 'UPDATE_DEAL_CLOSE_DATE' && cr.details?.['output']) {
                          <div class="mt-1.5 p-1.5 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded text-[10px] space-y-0.5">
                            <p class="font-semibold text-blue-700 dark:text-blue-400">Fecha de cierre actualizada</p>
                            @if (cr.details!['output']['oldCloseDate']) {
                              <p class="text-blue-600">Anterior: <span class="font-mono">{{ cr.details!['output']['oldCloseDate'] }}</span></p>
                            }
                            @if (cr.details!['output']['newCloseDate']) {
                              <p class="text-blue-600">Nueva: <span class="font-mono font-medium">{{ cr.details!['output']['newCloseDate'] }}</span></p>
                            }
                          </div>
                        }
                        <!-- RF-09: CHANGE_PIPELINE -->
                        @if (cr.details?.['actionType'] === 'CHANGE_PIPELINE' && cr.details?.['output']) {
                          <div class="mt-1.5 p-1.5 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded text-[10px] space-y-0.5">
                            <p class="font-semibold text-indigo-700 dark:text-indigo-400">Pipeline / ciclo actualizado</p>
                            @if (cr.details!['output']['oldPipelineId'] !== undefined) {
                              <p class="text-indigo-600">Pipeline anterior: <span class="font-mono">{{ cr.details!['output']['oldPipelineId'] }}</span></p>
                            }
                            @if (cr.details!['output']['newPipelineId'] !== undefined) {
                              <p class="text-indigo-600">Pipeline nuevo: <span class="font-mono font-medium">{{ cr.details!['output']['newPipelineId'] }}</span></p>
                            }
                            @if (cr.details!['output']['compatibilityMode']) {
                              <p class="text-amber-600">⚠ Modo compatibilidad.</p>
                            }
                          </div>
                        }
                        <!-- RF-08: SCHEDULE_MEETING -->
                        @if (cr.details?.['actionType'] === 'SCHEDULE_MEETING' && cr.details?.['output']) {
                          <div class="mt-1.5 p-1.5 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded text-[10px] space-y-0.5">
                            <p class="font-semibold text-indigo-700 dark:text-indigo-400">Reunión programada</p>
                            @if (cr.details!['output']['meetingId']) {
                              <p class="text-indigo-600">ID: <span class="font-mono">{{ cr.details!['output']['meetingId'] }}</span></p>
                            }
                            <p class="text-indigo-600">Calendario externo:
                              <span class="font-medium">{{ cr.details!['output']['calendarEventStatus'] ?? 'No solicitado' }}</span>
                            </p>
                          </div>
                        }
                      </div>
                    }

                    <!-- Info de espera RF-05 -->
                    @if (isWaitingResult(cr)) {
                      <div class="mt-2 p-2 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded text-xs">
                        <div class="flex items-center gap-1.5 text-purple-700 dark:text-purple-400 mb-1">
                          <svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                          </svg>
                          La inscripción quedó en espera.
                        </div>
                        <a routerLink="/automation/workflow-waits/queue"
                           class="text-purple-600 hover:underline">
                          → Ver cola de esperas
                        </a>
                      </div>
                    }

                    <!-- Tabla de condiciones evaluadas -->
                    @if (cr.details?.evaluatedConditions?.length) {
                      <table class="w-full mt-2 border-collapse">
                        <thead>
                          <tr class="text-[10px] text-gray-500">
                            <th class="text-left px-1 py-0.5 border border-gray-200 dark:border-gray-600">Prop</th>
                            <th class="text-left px-1 py-0.5 border border-gray-200 dark:border-gray-600">Op</th>
                            <th class="text-left px-1 py-0.5 border border-gray-200 dark:border-gray-600">Esp</th>
                            <th class="text-left px-1 py-0.5 border border-gray-200 dark:border-gray-600">Real</th>
                            <th class="px-1 py-0.5 border border-gray-200 dark:border-gray-600">OK</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (c of cr.details!.evaluatedConditions; track $index) {
                            <tr class="text-[10px]">
                              <td class="px-1 py-0.5 font-mono border border-gray-200 dark:border-gray-600">{{ c.property ?? '—' }}</td>
                              <td class="px-1 py-0.5 border border-gray-200 dark:border-gray-600">{{ operatorText(c.operator) }}</td>
                              <td class="px-1 py-0.5 font-mono border border-gray-200 dark:border-gray-600">{{ c.expected ?? '—' }}</td>
                              <td class="px-1 py-0.5 font-mono border border-gray-200 dark:border-gray-600">{{ c.actual ?? '—' }}</td>
                              <td class="px-1 py-0.5 text-center border border-gray-200 dark:border-gray-600"
                                  [ngClass]="c.result ? 'text-green-600' : 'text-red-500'">
                                {{ c.result ? '✓' : '✗' }}
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }

        <!-- Errores -->
        @if (result.errors?.length) {
          <div class="mt-3 p-2 bg-red-50 border border-red-200 rounded-lg">
            <p class="text-xs font-semibold text-red-700 mb-1">Errores:</p>
            @for (err of result.errors; track err) {
              <p class="text-xs text-red-600">• {{ err }}</p>
            }
          </div>
        }
      }
    </div>
  </div>
</div>
